import { Injectable } from "@angular/core";
import { KeycloakService } from "keycloak-angular";

/**
 * In-memory access to Keycloak tokens. Do not persist these to localStorage.
 * Tokens live on the Keycloak JS adapter; this service is the app-facing API.
 */
@Injectable({
  providedIn: "root",
})
export class AuthTokenService {
  constructor(private keycloak: KeycloakService) {}

  async getAccessToken(): Promise<string> {
    return this.keycloak.getToken();
  }

  getAccessTokenSnapshot(): string | undefined {
    return this.keycloak.getKeycloakInstance()?.token;
  }

  isLoggedIn(): boolean {
    return this.keycloak.isLoggedIn();
  }
}
